import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import PageLayout from '../common/PageLayout';
import '../css/Step1.css';
import { handleImportProcess } from '../utils/fileHandlers/importHandler';
import { importKoreanExcels } from '../utils/api/productApi';


const BulkProductRegister = () => {
  const [error, setError] = useState(null);
  const [statusMessage, setStatusMessage] = useState('waiting...');
  const [isImporting, setIsImporting] = useState(false);
  const [isFinished, setIsFinished] = useState(false);
  const [animatedText, setAnimatedText] = useState('Select All Excel Files');

  useEffect(() => {
    // 기존 텍스트 애니메이션 로직 유지
    if (isImporting) {
      let currentIndex = 0;
      const fullText = 'Send Excel to DB Server...';
      const timer = setInterval(() => {
        setAnimatedText(fullText.slice(0, currentIndex + 1));
        currentIndex++;
        if (currentIndex === fullText.length) currentIndex = 0;
      }, 150);
      return () => clearInterval(timer);
    }
  }, [isImporting]);

  const handleSubmit = async (formData) => {  // formData를 직접 받음
    setError("");
    setIsImporting(true);

    try {
      // FormData 내용 확인
      console.log('Received FormData entries:');
      for (let pair of formData.entries()) {
        console.log('FormData entry:', pair[0], pair[1]);
      }

      const result = await handleImportProcess(() => importKoreanExcels(formData), 'All Excel Files');

      if (!result.success) {
        setStatusMessage(`Failed to upload files: ${result.message}`);
        return;
      }

      setStatusMessage("All files uploaded successfully.");
      setIsFinished(true);
    } catch (error) {
      console.error('Error:', error);
      setError('Error occurred during upload process.');
      setStatusMessage('Upload failed.');
    } finally {
      setIsImporting(false);
    }
  };
  const validateFile = (file) => {
    const validTypes = [
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      "application/vnd.ms-excel"
    ];
    return validTypes.includes(file.type);
  };

  return (
    <PageLayout
      title="Insert Korean Excel to DB"
      isFileUpload={true}
      submitButtonText="Upload All Excel Files"
      fileUploadButtonText="Choose Excel Files"
      description={
        <p className={`animated-text ${isImporting ? 'importing' : ''}`}>
          {animatedText}
        </p>
      }
      onSubmit={handleSubmit}
      validateFile={validateFile}
      error={error}
      statusMessage={statusMessage}
      multiple={true}
      acceptTypes=".xlsx,.xls"
    >
      {isFinished && !isImporting && (
        <Link to="/bulk-db-conversion" className="next-button">
          Next
        </Link>
      )}
    </PageLayout>
  );
};

export default BulkProductRegister;